<script>
export default {
   
  getAPIHost() {
    try {
      let host = window.location.origin;
      host = host.toLowerCase();
      if (host.indexOf("alfreddos.com") > 0) 
        return "https://api.alfreddos.com";
    } catch (err) {
        return;
    }
    return process.env.VUE_APP_APIHOST;
  },
   
};
</script>